import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";

//Miscellaneous

//Icons

class NoRecords extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  imageImport = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  render() {
    const { t } = this.props;
    const component = this.props.component;
    const pageDashboard = component === "dashboard";

    const img = this.imageImport(
      require.context(
        "../../assets/images",
        false,
        /\.(png|jpe?g|svg)$/
      )
    );

    return (
      <div className="no-records">
        <img src={img["no-records.png"]} alt="no-records" />
        <label>{t('norecord.norecords')}</label>
        {pageDashboard ? (
          <>
            <p>{t('norecord.norecords')}</p>
          </>
        ) : (
          <></>
        )}
      </div>
    );
  }
}

export default withNamespaces("translation")(NoRecords);
